import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useRemoveEmployeeFromEmployeeGroup } from 'src/features/employees-groups/api/hooks/employees/use-remove-employees-from-group';

interface Props extends DialogActions {
  employeeGroupToken: string;
  employeeGroupName: string;
  employeeToken: string;
}

export const RemoveEmployeesFromGroupDialog = ({
  open,
  onCancel,
  employeeGroupToken,
  employeeGroupName,
  employeeToken,
}: Props) => {
  const { t } = useTranslation('employeesGroups');

  const {
    mutate: removeEmployeeFromEmployeeGroup,
    isPending: isRemovingEmployeeFromEmployeeGroup,
  } = useRemoveEmployeeFromEmployeeGroup(onCancel);

  return (
    <Dialog
      variant="warning"
      title={t('employees.removeEmployeesFromGroupDialog.title')}
      open={open}
      onCancel={onCancel}
      onConfirm={() =>
        removeEmployeeFromEmployeeGroup({
          employeeGroupToken,
          employeeToken,
          bookingsDecisions: {
            cancelBookingDecisions: [],
            keepBookingUnchangedDecisions: [],
            moveBookingDecisions: [],
          },
          bookingsDecisionsReason: '',
        })
      }
      isConfirmButtonSubmitting={isRemovingEmployeeFromEmployeeGroup}
      confirmButtonText={t(
        'employees.removeEmployeesFromGroupDialog.confirmButtonText',
      )}>
      <Typography variant="body2">
        {t('employees.removeEmployeesFromGroupDialog.message', {
          groupName: employeeGroupName,
        })}
      </Typography>
    </Dialog>
  );
};
